<template>
  <v-data-table :headers="headers" :items="filteredGroups" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" fullscreen @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova caixa
            </v-btn>
          </template>

          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

              <v-spacer />

              <v-toolbar-items>
                <v-btn dark text @click="save"> Salvar </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-container fluid>
              <v-row dense>
                <v-col cols="5">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="editedItem.name"
                    label="Nome"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-select
                    outlined
                    dense
                    hide-details
                    v-model="editedItem.material"
                    label="Material"
                    :items="contactLensTestMaterials"
                    item-text="name"
                    return-object
                  />
                </v-col>

                <v-col>
                  <v-select
                    outlined
                    dense
                    hide-details
                    v-model="editedItem.manufacturer"
                    label="Fabricante"
                    :items="contactLensTestManufacturers"
                    item-text="name"
                    return-object
                  />
                </v-col>

                <v-col>
                  <v-select
                    outlined
                    dense
                    hide-details
                    v-model="editedItem.layout"
                    label="Desenho"
                    :items="contactLensTestLayouts"
                    item-text="name"
                    return-object
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <LensList
                    v-if="editedItem.id"
                    :contactLensGroup="editedItem"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_contact_len"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_contact_len"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há caixas cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import LensList from "@/components/config/contact_len/lens/list.vue";

export default {
  name: "ContactLenGroupConfig",
  components: {
    LensList,
  },
  apollo: {
    contactLensTestGroups: {
      query: require("@/graphql/contact_lens_test/groups.gql"),
      pollInterval: 20000,
    },
    contactLensTestMaterials: {
      query: require("@/graphql/contact_lens_test/materials.gql"),
    },
    contactLensTestLayouts: {
      query: require("@/graphql/contact_lens_test/layouts.gql"),
    },
    contactLensTestManufacturers: {
      query: require("@/graphql/contact_lens_test/manufacturers.gql"),
    },
  },
  data() {
    return {
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Material", value: "material.name" },
        { text: "Fabricante", value: "manufacturer.name" },
        { text: "Desenho", value: "layout.name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredGroups() {
      let groups = this.contactLensTestGroups;

      if (this.filter) {
        groups = this.lodash.filter(
          groups,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return groups;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova caixa" : "Editar caixa";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredGroups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse caixa?")) {
        this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/delete_contact_lens_group.gql"),
          variables: {
            contactLensGroupId: item.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Caixa deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/contact_lens_test/save_contact_lens_group.gql"),
        variables: {
          contactLensGroupId: this.lodash.get(this.editedItem, "id", ""),
          name: this.editedItem.name,
          contactLensMaterialId: this.lodash.get(
            this.editedItem,
            "material.id",
            ""
          ),
          contactLensManufacturerId: this.lodash.get(
            this.editedItem,
            "manufacturer.id",
            ""
          ),
          contactLensLayoutId: this.lodash.get(
            this.editedItem,
            "layout.id",
            ""
          ),
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.contactLensTestGroups.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
